module.exports = __webpack_public_path__ + "img/logo1.3676ed80.png";